import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Usuarios from './Usuarios';
import Mensagens from './Mensagens';

import config from '../config.json';
import Metas from './Metas';
import Logs from './Logs';
import Indices from './Indices'
import Distribuidoras from './Distribuidoras';
import ConfiguracaoEmpresa from './ConfiguracaoEmpresa';

import { validateUser } from './api';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  // Valida usuario
  const navigate = useNavigate();
  useEffect(() => {
    validateuser()
  },[])
  const validateuser = async () => {
    const teste = await validateUser();
    if(!teste.ok){
      localStorage.removeItem('userData');
      localStorage.removeItem('userToken');
      config.user = {}
      navigate('/', { replace: true });
      window.alert('Sessão expirada, faça o login novamente')
      return
    }
    localStorage.setItem('userData', JSON.stringify(teste.usuario));
    config.user = teste.usuario
  }
  // -------------
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function ConfiguracaoPage() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" centered>
          <Tab label="Usuários" {...a11yProps(0)} />
          <Tab label="Mensagens" {...a11yProps(1)} />
          <Tab label="Metas" {...a11yProps(2)} />
          <Tab label="Logs" {...a11yProps(3)} />
          <Tab label="Índices" {...a11yProps(4)} />
          <Tab label="Distribuidoras" {...a11yProps(5)} />
          <Tab label="Empresa" {...a11yProps(6)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <Usuarios />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <Mensagens />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <Metas />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <Logs />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={4}>
        <Indices />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={5}>
        <Distribuidoras />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={6}>
        <ConfiguracaoEmpresa />
      </CustomTabPanel>
    </Box>
  );
}